export default __webpack_public_path__ + "media/images/mailer/icon_email-07eaf000249a54dae76b2937a834c3ae.png";